import axios from 'axios'

export default() => {
  return axios.create({
    // TODO Fetch different base URL based on dev/production env
    baseURL: 'https://demo.vibevision.io/',
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    // Convert POST request data to JSON string
    transformRequest: [(data) => {
      return JSON.stringify(data)
    }]
  })
}
